import { render, staticRenderFns } from "./LayananSuperior.vue?vue&type=template&id=1d4c28fb&scoped=true"
import script from "./LayananSuperior.vue?vue&type=script&lang=js"
export * from "./LayananSuperior.vue?vue&type=script&lang=js"
import style0 from "./LayananSuperior.vue?vue&type=style&index=0&id=1d4c28fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c28fb",
  null
  
)

export default component.exports